
import { useEffect, useState } from 'react';
import circle1 from '../static/images/circle-1.svg';
import circle2 from '../static/images/circle-2.svg';
import circle3 from '../static/images/circle-3.svg';

import { request } from '../utils/request';

import '../App.css';

const Warning = () => {
  const [warningData, setWarningData] = useState({});

  useEffect(() => {
    getWarningData();
  }, [])

  const getWarningData = async () => {
    const res = await request('warn');
    setWarningData(res.data);
  }

  return (
    <div className="card warning">
      <h3 className="card-title">预警统计</h3>
      <div className="card-body warning">
        <div className="warning-item">
          <img src={circle1} alt='' />
          <span className="count">{warningData.today}</span>
        </div>
        <div className="warning-item">
          <img src={circle2} alt='' />
          <span className="count">{warningData.handled}</span>
        </div>
        <div className="warning-item">
          <img src={circle3} alt='' />
          <span className="count">{warningData.unhandled}</span>
        </div>
      </div>
    </div>
  );
}

export default Warning;
